<script setup lang="ts">
    import { useShippingStore } from '@/stores/shippingStore';
    import { ShippingPackageChange } from '@/shared/helpers/api';
    import { getReleaseLink } from '@/shared/helpers/routing';

    const store = useShippingStore();

    function changeIcon(change: ShippingPackageChange): string {
        if (change.isFailure)
            return 'close-circle';
        if (change.isApplied)
            return 'check-circle';
        if (!change.isAuthorized)
            return 'alert';
        return '';
    }

    function changeIconClass(change: ShippingPackageChange): string {
        if (change.isFailure)
            return 'shipping-color-failure';
        if (change.isApplied)
            return 'shipping-color-ok';
        if (!change.isAuthorized)
            return 'shipping-change-unauthorized';
        return '';
    }

    interface IHaveReleaseId {
        releaseId: number;
    }

    function isContentReleaseChange(change: ShippingPackageChange): boolean {
        return change.changeType.endsWith('Shipping.Changes.ContentReleaseChange');
    }

    function getReleaseId(change: ShippingPackageChange): number {
        const deserializedData: IHaveReleaseId = JSON.parse(change.data);
        return deserializedData.releaseId;
    }
</script>

<template>
    <div
        v-if="store.showChanges"
        class="mb-5 shipping-change-container">
        <div class="shipping-section-header block">
            Changes
        </div>
        <div
            v-for="change in store.selectedPackage!.changes"
            :key="change.sequenceNumber"
            class="shipping-change-box is-flex is-align-items-start">
            <div class="shipping-change-number">
                {{ change.sequenceNumber }}
            </div>
            <div class="shipping-change-icon">
                <b-icon
                    :icon="changeIcon(change)"
                    :custom-class="changeIconClass(change)"
                    size="is-small" />
            </div>
            <div class="shipping-change-description">
                {{ change.description }}
            </div>
            <router-link
                v-if="isContentReleaseChange(change)"
                :to="getReleaseLink(getReleaseId(change))">
                View release
            </router-link>
        </div>
    </div>
</template>

<style scoped>
.shipping-change-box {
    border-top: solid 1px #999999;
    padding: 1em;
    background-color: #eeeeee;
}
.shipping-change-container {
    border-bottom: solid 1px #999999;
}
.shipping-change-number {
    width: 2em;
}
.shipping-change-icon {
    width: 3em;
}
.shipping-change-description {
    white-space: pre;
    text-wrap: wrap;
    flex-grow: 1;
}
.shipping-change-unauthorized {
    color: darkorange;
}
</style>
